import { toReleaseLocale } from 'fym-shared/src/releases/resolve';
import { config } from '../../../config/config';

/**
 * The website changelog anchor of one version, on the configured website (staging links staging):
 * `<site>/changelog#10.1.0` in English, `<site>/de/changelog#10.1.0` in the other locales. The
 * same rule as `music24-api/src/services/releaseBrief/changelogUrl.ts`.
 */
export function changelogUrl(locale: string, version: string, siteUrl: string = config.smartLinksWebURL): string {
  const site = siteUrl.endsWith('/') ? siteUrl : `${siteUrl}/`;
  const releaseLocale = toReleaseLocale(locale);
  const prefix = releaseLocale === 'en' ? '' : `${releaseLocale}/`;
  return `${site}${prefix}changelog#${version}`;
}
